import { webClient } from "@shared/apis"
import {Partner} from "./account";

const partnersApi = {
  get: (id: number) => webClient.get<Partner>(`/partners/${id}`)
}

export default partnersApi
